import { React } from 'react';
import Hero from './components/Hero';
import './styles/soul.scss';
import SoulMain from './components/hero-items/SoulMain';
import Character from './components/Character';
import SoulData from './data/SoulData';
import Pengu from './components/Pengu';

const Soul = () => {
    return (
        <div className="soul-container">
            <Hero className="home" 
            first="" 
            second ="/img/keyart/banner-second.jpg" 
            gradOne=".25turn, rgba(248,240,200, 1) 70%, rgba(248,240,200, 1) )"
            gradTwo=".75turn, rgba(0,0,0,0) 75%, rgba(248,240,200, 1))"
            logo="./img/logos/SoulNomad_Logo_Final_small.png"
            hide= 'true'
            color="rgba(248,240,200, 1)"
            contents={<SoulMain />}/>
            <section className="story-container">
                <div className="story-wrapper">
                    <div className="story-info">
                        <div className="image-wrapper">
                            <img src="./img/logos/nomad-story.png" alt="STORY" className="story-title" />
                        </div>
                        <div className="story-body">
                            <p>
                            The continent of Prodesto... The grueling war had finally ended, and one man had unified the land. Lord Median the Conqueror... Though only one man, his heroism swept across the world.
                            </p>
                            <p>
                            The harmonious empire stood for 10 years, before it crumbled once more. Lord Median and his son passed away, and Prodesto returned to a state of bloody war.
                            </p>
                            <p>
                            It was then that a clarion vesper rang throughout the halls of history. Median's daughter, Layna, had come into her own and became a true leader. Neighboring countries formed treaties, and for a moment the world knew peace.
                            </p>
                            <p>
                            But then the world was darkened by a single shadow and its cruel heralds. The violent echoes of agony and murder shattered the land. The shaky alliances were pushed to their limits by the merciless creatures. But human as they were, they fell victim to weakness and temptation. Some cowered and fled, while others pledged allegiance to the beasts.
                            </p>
                            <p>                        
                            Layna rallied her few remaining comrades for a final confrontation. The venerable warrior queen sacrificed her life to banish the shadow. They were both consumed, and the three behemoths fell silent... 
                            </p>
                        </div>
                    </div>
                    <div className="story-art">
                            <img src="./img/keyart/soul-keyart1.jpg" alt="soul-keyart" />
                    </div>
                </div>
            </section>
            <Character charList = {SoulData} showStats = {false} game="nomad"/>
            <Pengu link="./products"/>
        </div>
    );
}


export default Soul;